import CustomComponent from '../CustomComponent';

export class AppFeatureComponent extends CustomComponent {
	static key = 'lta-app-feature';

	static get observedAttributes() {
		return ['content-alignment', 'title', 'subtitle', 'feature-image', 'overaly-image', 'classes'];
	}

	render() {
		const {
			contentAlignment = 'right',
			title = '',
			subtitle = '',
			featureImage = '',
			overlayImage = '',
			classes = ''
		} = this.props;

		const isRight = contentAlignment === 'right';

		const imagePositionClass = isRight ? 'wrapper-position-right' : 'wrapper-position-left';

		return `
            <div class="lta-app-feature 
				${isRight 
					? 'lta-app-feature__content-right' 
					: 'lta-app-feature__content-left'
				} ${classes}
			">
                <div class="lta-app-feature__image-container ${imagePositionClass}">
                    <img src="${featureImage}" alt="Alt text" class="lta-app-feature__primary-image" />
                        ${
                            overlayImage
							? 	`<div class="lta-app-feature__overlay-image-wrapper">
									<div 
										class="lta-app-feature__overlay-image-container"
									>
										<img 
											src="${overlayImage}" 
											alt="Overlay Image" 
											class="
												${overlayImage 
													? "lta-app-feature__overlay-image"
													: ""
												}"
											/>
									</div>
								</div>`
							: ''
                        }
                </div>
                <div class="lta-app-feature__text-container">
                    <div class="lta-app-feature__text-wrapper">
                        <div class="lta-app-feature__title u-hero-heading-1">${title}</div>
                        <div class="lta-app-feature__sub-title">${subtitle}</div>
                    </div>
                </div>
            </div>
        `;
	}
}

export default AppFeatureComponent;
